import i18n from "@/i18n";
import { BaseEnum, enumCodeToLabel } from "../BaseEnum";

export class EsgObjectiveTypes extends BaseEnum {
  static MITIGATION = 1;
  static ADAPTATION = 2;
  static WATER = 3;
  static CIRCULAR_ECONOMY = 4;
  static POLLUTION_PREVENTION = 5;
  static BIODIVERSITY = 6;

  static Codes = [
    this.MITIGATION,
    this.ADAPTATION,
    this.WATER,
    this.CIRCULAR_ECONOMY,
    this.POLLUTION_PREVENTION,
    this.BIODIVERSITY,
  ];

  static _labelKeys = [
    "esg.objectives.MITIGATION",
    "esg.objectives.ADAPTATION",
    "esg.objectives.WATER",
    "esg.objectives.CIRCULAR_ECONOMY",
    "esg.objectives.POLLUTION_PREVENTION",
    "esg.objectives.BIODIVERSITY",
  ];

  static _descriptionKeys = [
    "esg.objectives.MITIGATION-description",
    "esg.objectives.ADAPTATION-description",
    "esg.objectives.WATER-description",
    "esg.objectives.CIRCULAR_ECONOMY-description",
    "esg.objectives.POLLUTION_PREVENTION-description",
    "esg.objectives.BIODIVERSITY-description",
  ];

  static get Description() {
    return this._descriptionKeys.map((key) => i18n.t(key));
  }

  static codeToDescription(code) {
    return enumCodeToLabel(this.Codes, this.Description, code);
  }
}
